export const DEFAULT_CURRENCY = 'USD';

/** Tuneboom's own app plans are billed through Shopify in USD, whatever the shop's currency. */
export const BILLING_CURRENCY = 'USD';

export function shopCurrency(shop: { shopify?: { currency?: string | null } | null } | null | undefined): string {
  return shop?.shopify?.currency || DEFAULT_CURRENCY;
}
